// To clean of null value and display
const fieldMixin = {
  methods: {
    formatNullVal(val) {
      if (val === undefined) {
        return '-'
      } else if (val === null) {
        return '-'
      } else {
        return val
      }
    },
    formatBoolean(val) {
      if (val === undefined) {
        return 'No'
      } else {
        if (val === true) {
          return 'Yes'
        } else {
          return 'No'
        }
      }
    },
    checkNullVal(data) {
      if (data.includes('undefined')) {
        return undefined
      } else {
        return data
      }
    }
  }
}

export default fieldMixin
